import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';

// Used 6x across 6 TopBar files — flex container that centers nav content and expands to fill space
export const TopBarGrowBox = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  flexGrow: 1,
});

// Used 3x across 3 TopBar files — clickable persona row (avatar + border-radius wrapper)
export const PersonIconWrapper = styled(Box)({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'flex-end',
  borderRadius: 4, // matches sx borderRadius: 1 (4px in MUI default spacing)
  cursor: 'pointer',
});
